<template>
    <div id="app" class="sales-channel" :class="themeClass">
        <LoadingSpinner v-if="loading" class="spinner" :size="140" />
        <Default v-else :style="cssProps">
            <router-view />
        </Default>
    </div>
</template>

<script>
import contrast from 'contrast';
import Default from '@/layouts/Default';
import LoadingSpinner from './components/global/LoadingSpinner';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'App',
    components: { Default, LoadingSpinner },
    data() {
        return {
            loading: true,
        };
    },
    computed: {
        themeClass() {
            return this.game?.name?.toLowerCase().replace(/[^a-z0-9]/gi, '-') || '';
        },
        cssProps() {
            const ts = this.themeSettings;
            const colors = {
                primary: ts?.primaryColor || '#F16C2F',
                secondary: ts?.secondaryColor || '#1B3C70',
                body: ts?.bodyColor || '#56646E',
            };
            const contrastColors = {
                primary: contrast(colors.primary) === 'dark' ? '#FFFFFF' : '#333333',
                secondary: contrast(colors.secondary) === 'dark' ? '#FFFFFF' : '#333333',
            };

            return {
                '--primary-color': colors.primary,
                '--primary-contrast-color': contrastColors.primary,
                '--secondary-color': colors.secondary,
                '--secondary-contrast-color': contrastColors.secondary,
                '--primary-text-color': colors.body,
                '--info-color': '#2196f3',
                '--success-color': '#4caf50',
                '--warning-color': '#fb8c00',
                '--error-color': '#ff5252',
            };
        },
        ...mapState(['game']),
        ...mapGetters(['themeSettings']),
    },
    async mounted() {
        if (!process.env.VUE_APP_EDITOR) {
            this.initialize();
        }

        this.loading = false;
    },
    methods: {
        ...mapActions(['initialize']),
    },
};
</script>

<style lang="scss">
@import '~@/assets/scss/global/global.scss';

* {
    box-sizing: border-box;
}

#app {
    // -webkit-font-smoothing: antialiased;
    // -moz-osx-font-smoothing: grayscale;
    color: #56646e;
    min-height: 100vh;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: var(--primary-text-color);
    }
}

.spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
